// seo.component.ts
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;

interface SeoField {
  key: string;
  label: string;
  value: string;
  original?: string;
  editing: boolean;
}

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: ['./seo.component.scss']
})
export class SeoComponent implements OnInit {
  seoFields: SeoField[] = [];
  loading = false;

  previewUrl: SafeUrl | null = null;
  imageFile: File | null = null;
  imageKey: string = '';
  showToast = false;

  constructor(
    private apiService: ApiService,
    private themingService: ThemingService,
    private sanitizer: DomSanitizer,
    private lambdaService: LambdaService
  ) {}

  ngOnInit(): void {
    this.getSeoSettings();
  }

  async getSeoSettings() {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getSeoSettings(this.themingService.shopId);
      const seoData = response[0];
      const seo = seoData && seoData[0] ? seoData[0] : {};
  
      this.seoFields = [
        { key: 'description', label: 'Description', value: seo.description || '', editing: false },
        { key: 'keywords', label: 'Keywords', value: seo.keywords || '', editing: false },
        { key: 'og:title', label: 'OG Title', value: seo.ogTitle || '', editing: false },
        { key: 'og:description', label: 'OG Description', value: seo.ogDescription || '', editing: false },
        { key: 'og:url', label: 'OG URL', value: seo.ogURL || '', editing: false },
        { key: 'og:image', label: 'OG Image URL', value: seo.ogImageURL || '', editing: false },
      ];
    } catch (error) {
      console.error('Error fetching SEO settings:', error);
    } finally {
      this.loading = false;
    }
  }
  
  toggleEdit(field: SeoField) {
    if (!field.editing) {
      field.original = field.value;
      field.editing = true;
    } else {
      this.saveField(field);
    }
  }

  cancelEdit(field: SeoField) {
    field.value = field.original || field.value;
    field.editing = false;
    this.previewUrl = null;
    this.imageFile = null;
  }

  async saveField(field: SeoField) {
    this.loading = true;

    if (field.key === 'og:image' && this.imageFile) {
      this.imageKey = `${this.themingService.shopId}/${environment.stage}/images/logos/og-image.jpg`;

      try {
        await this.lambdaService.uploadFile(this.imageKey, this.imageFile, {
          position: 0,
          type: 'seo-image'
        });

        const newImageUrl = `https://mobydyg-files.s3.amazonaws.com/${this.imageKey}`;
        field.value = newImageUrl;
      } catch (error) {
        console.error('Error al subir imagen SEO:', error);
        this.loading = false;
        return;
      }
    }

    const payload: any = {
      shopId: this.themingService.shopId
    };

    for (const f of this.seoFields) {
      switch (f.key) {
        case 'description':
          payload.description = f.value;
          break;
        case 'keywords':
          payload.keywords = f.value;
          break;
        case 'og:title':
          payload.ogTitle = f.value;
          break;
        case 'og:description':
          payload.ogDescription = f.value;
          break;
        case 'og:image':
          payload.ogImageURL = f.value;
          break;
        case 'og:url':
          payload.ogURL = f.value;
          break;
      }
    }

    try {
      const response: any = await this.lambdaService.updateSeoSettings(
        payload.shopId,
        payload.description,
        payload.keywords,
        payload.ogTitle,
        payload.ogDescription,
        payload.ogImageURL,
        payload.ogURL
      );

      if (response.status === 200) {
        $('#successSeoModal').modal('show');
        field.editing = false;
        this.imageFile = null;
        this.previewUrl = null;
      }
    } catch (error) {
      $('#errorSeoModal').modal('show');
      console.error(`Error guardando ${field.key}:`, error);
    } finally {
      this.loading = false;
    }
  }

  onImageSelected(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    this.imageFile = file;
    this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      this.showToast = true;
      setTimeout(() => this.showToast = false, 2000);
    }).catch(err => {
      console.error('Error al copiar:', err);
    });
  }

  closeModal(): void {
    $('#successSeoModal').modal('hide');
    $('#errorSeoModal').modal('hide');
  }
}
